export function checkForWin(board, setBoard, ROW, player) {
    // Handle horizontal wins
    for (let i = 0; i < ROW; i++) {
        if (board[i].every(b => b.value === player)) {
            board[i] = board[i].map(b => ({
                ...b,
                hasWon: true
            }));
            return true;
        }
    }

    // Handle verticals wins
    // board[0][0].value === player && board[1][0] === player && board[2][0] == player
    const columnValues = [];
    for (let i = 0; i < ROW; i++) {
        const singleRow = [];
        for (let j = 0; j < ROW; j++) {
            let val = board[j][i];
            singleRow.push(val)
        }
        columnValues.push(singleRow)
    }

    for (let i = 0; i < ROW; i++) {

        if (columnValues[i].every(b => b.value === player)) {
            const winningIds = new Set(columnValues[i].map(b => b.id));

            setBoard(prev =>
                prev.map(row =>
                    row.map(cell =>
                        winningIds.has(cell.id)
                            ? { ...cell, hasWon: true }
                            : cell
                    )
                )
            );

            return true;
        }
    }

    // Handle diagonal (\) wins
    // board[0][0].value === player && board[1][1] === player && board[2][2] == player
    const backSlashVals = []
    for (let i = 0; i < ROW; i++) {
        let val = board[i][i];
        backSlashVals.push(val)
    }

    if (backSlashVals.every(b => b.value === player)) {
        const winningIds = new Set(backSlashVals.map(b => b.id));

        setBoard(prev =>
            prev.map(row =>
                row.map(cell =>
                    winningIds.has(cell.id)
                        ? { ...cell, hasWon: true }
                        : cell
                )
            )
        );
        return true;
    }

    // Handle diagonal (/) wins
    // board[0][2] === player && board[1][1] === player && board[2][0] === player    
    const forwardSlashVals = [];
    for (let i = 0; i < ROW; i++) {
        const curr = board[i][(ROW - 1) - i];

        forwardSlashVals.push(curr);
    }

    if (forwardSlashVals.every(b => b.value === player)) {
        const winningIds = new Set(forwardSlashVals.map(b => b.id));

        setBoard(prev =>
            prev.map(row =>
                row.map(cell =>
                    winningIds.has(cell.id)
                        ? { ...cell, hasWon: true }
                        : cell
                )
            )
        );
        return true;
    }

    return false;
}

export function checkForDraw(ROW, COLUMN, board) {
    let counter = ROW * COLUMN;
    for (let i = 0; i < ROW; i++) {
        for (let j = 0; j < ROW; j++) {
            let val = board[j][i].value;
            if (val === "X" || val === "O") {
                counter--;
            }
        }
    }
    return (counter === 0)
}